import AbstractParallelogram from "./AbstractParallelogram";

export default class ParallelogramFlipHorizontal extends AbstractParallelogram {
	static NAME = "parallelogram-flip-horizontal";

	get_name() {
		return ParallelogramFlipHorizontal.NAME;
	}
}
